// Liga os filtros do menu lateral (Minhas, Aguardando, Com a IA, Todas) às abas
// da lista de conversas do Chatwoot (me / unassigned / all). O menu manda pela
// URL (?aba=unassigned) e a lista devolve a aba em uso por `abaAtual`, que o
// menu lê para marcar o item ativo. Entra no ChatList.vue do core por um patch
// (ver custom/docs/PATCHES.md).
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import wootConstants from 'dashboard/constants/globals';
import { timeDaIa } from './fila';

const { ASSIGNEE_TYPE, SORT_BY_TYPE } = wootConstants;
const ABAS = Object.values(ASSIGNEE_TYPE);

// A aba da lista aberta agora (null sem lista na tela).
export const abaAtual = ref(null);

// "Aguardando" é a fila: quem espera há mais tempo primeiro. As outras voltam
// para a ordem que a pessoa escolheu na lista.
const ordemDa = (aba, ordemSalva) =>
  aba === ASSIGNEE_TYPE.UNASSIGNED
    ? SORT_BY_TYPE.WAITING_SINCE_ASC
    : ordemSalva() || SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC;

export const useAbaDaLista = ({
  activeAssigneeTab,
  activeSortBy,
  updateAssigneeTab,
  onBasicFilterChange,
  ordemSalva,
  store,
}) => {
  const route = useRoute();
  const router = useRouter();

  const aplica = aba => {
    if (!ABAS.includes(aba)) return;

    const ordem = ordemDa(aba, ordemSalva);
    if (aba === activeAssigneeTab.value) {
      if (ordem !== activeSortBy.value) onBasicFilterChange(ordem, 'sort');
      return;
    }
    // A ordem antes da aba: a troca de aba já busca com a ordem nova.
    activeSortBy.value = ordem;
    store.dispatch('setChatSortFilter', ordem);
    updateAssigneeTab(aba);
  };

  // Depois do onMounted do ChatList (que lê a ordem salva e faz a 1ª busca).
  onMounted(() => aplica(route.query.aba));
  watch(() => route.query.aba, aplica);

  // Aba trocada na própria lista: a URL acompanha, para o menu e o voltar. Só
  // depois de montar: antes disso a aba ainda é a padrão e a URL é que manda.
  abaAtual.value = activeAssigneeTab.value;
  watch(activeAssigneeTab, aba => {
    abaAtual.value = aba;
    if (route.query.aba && route.query.aba !== aba) {
      router.replace({ query: { ...route.query, aba } });
    }
  });

  onUnmounted(() => {
    abaAtual.value = null;
  });

  // "Com a IA" é a lista do time da IA: todas as conversas dele, sem abas (lá
  // ninguém é "meu" nem "sem atendente": a IA é quem atende).
  const naListaDaIa = computed(
    () =>
      ['team_conversations', 'conversations_through_team'].includes(
        route.name
      ) &&
      !!timeDaIa.value &&
      String(route.params.teamId) === String(timeDaIa.value)
  );
  watch(naListaDaIa, ehDaIa => ehDaIa && aplica(ASSIGNEE_TYPE.ALL));
  onMounted(() => naListaDaIa.value && aplica(ASSIGNEE_TYPE.ALL));

  // Na lista geral as abas da lista repetem o menu e somem. Numa caixa, time ou
  // etiqueta elas ficam: é como separar as minhas das sem atendente ali dentro.
  const escondeAbas = computed(
    () =>
      ['home', 'inbox_conversation'].includes(route.name) || naListaDaIa.value
  );
  return { escondeAbas };
};
